import { ArrowRight, MapPin } from "lucide-react";
import React from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";

import api from "api";
import { CircularProgress } from "@mui/material";

const CourseCard = ({ id, title, thumbnail, cta }) => {
  return (
    <Link to={`/free-class/${id}`}>
      <div className="bg-white rounded-lg overflow-hidden border border-[#FFFFFF] flex flex-col h-full w-full">
        <div className="relative overflow-hidden">
          <img
            src={thumbnail}
            alt="thumbnail"
            className="w-full h-44 object-cover rounded-t-lg"
          />
        </div>

        <div className="p-4 flex flex-col flex-1">
          <h3 className="text-lg leading-6 font-bold text-[#2f2d31] mb-2 line-clamp-2 overflow-hidden">
            {title}
          </h3>
          <p className="text-[#79747E] text-sm line-clamp-2 overflow-hidden font-medium">
            {cta}
          </p>
          <div className="mt-auto pt-4 px-5">
            <button
              className="w-full rounded-3xl px-4 py-1.5 text-white flex justify-center gap-1 items-center cursor-pointer"
              style={{
                background:
                  "linear-gradient(91.24deg, #AC5EFF -0.2%, #4583F2 99.8%)",
              }}
            >
              <span className="text-sm font-extrabold">বিস্তারিত দেখুন</span>
              <ArrowRight className="w-4 h-auto" />
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
};

const FreeCourseClass = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["free-class"],
    queryFn: api.course.getFreeClasss,
  });

  const getContainerStyles = () => {
    if (!data || data?.length === 0) return "";

    return "flex flex-wrap gap-7 pt-4 w-full justify-center";
  };

  const getCardWidth = () => {
    if (!data) return "w-full md:w-64";
    if (data?.length === 1) {
      return "w-full md:w-80";
    } else if (data?.length === 2) {
      return "w-full md:w-80";
    } else if (data?.length === 3) {
      return "w-full md:w-[calc(50%-14px)] lg:w-[calc(33.333%-19px)]";
    } else {
      return "w-full md:w-80 lg:w-90";
    }
  };

  return (
    <section className="px-5 py-10 md:px-16 md:pt-16 max-w-7xl mx-auto">
      <div
        className="p-5 md:p-10 rounded-2xl boder border-solid border-[#CFCFFF33]"
        style={{
          background:
            "linear-gradient(127.57deg, rgba(31, 39, 89, 0.15) 9.77%, rgba(108, 52, 206, 0.15) 48.42%, rgba(108, 52, 206, 0.15) 55.06%, rgba(31, 39, 89, 0.15) 93.1%)",
        }}
      >
        <div className="flex flex-col space-y-2 items-center text-center max-w-3xl mx-auto">
          <h2 className="text-xl font-bold text-white">
            দেশজুড়ে অসংখ্য লার্নাররা আমাদের প্ল্যাটফর্মে ইন্ডাস্ট্রি থেকে
            ডিরেক্ট গাইডেন্স পাচ্ছেন টপ প্রফেশনালদের কাছ থেকে। এবার অনলাইন আর
            অফলাইন- দুই জায়গাতেই ফ্রি ক্লাসে পার্টিসিপেট করে আমাদের স্কিল
            ডেভেলপমেন্ট জার্নির অংশ হতে পারবেন!!!
          </h2>

          <div className="flex bg-[#666eff13] size-fit mx-auto items-center justify-center gap-1 text-sm text-[#98C6FF] mt-2 rounded-2xl py-3 px-4">
            <MapPin size={16} />
            <span>আদাবর, মোহাম্মদপুর, ঢাকা</span>
          </div>
        </div>

        <div>
          {isLoading ? (
            <div className="flex items-center justify-center p-5">
              <CircularProgress size={28} sx={{ color: "white" }} />
            </div>
          ) : (
            <div className={getContainerStyles()}>
              {data.map((course) => (
                <div key={course.id} className={getCardWidth()}>
                  <CourseCard {...course} />
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="flex justify-center mt-8 gap-4">
          <Link to="/free-class-booking">
            <button
              className="flex gap-2 items-center text-white px-6 py-2.5 rounded-3xl text-xs md:text-sm font-semibold"
              style={{
                background:
                  "linear-gradient(91.24deg, #AC5EFF -0.2%, #4583F2 99.8%)",
              }}
            >
              <span> ফ্রি ক্লাস বুক করুন</span>
              <ArrowRight className="w-4 h-auto hidden md:block" />
            </button>
          </Link>
          <Link to="/free-classes">
            <button
              className="px-6 py-2 text-xs md:text-sm text-white rounded-full font-semibold"
              style={{
                background: "transparent",
                border: "1px solid transparent",
                borderRadius: "999px",
                backgroundImage:
                  "linear-gradient(rgba(31, 39, 89, 0.9), rgba(31, 39, 89, 0.9)), linear-gradient(90deg, #D8D8FF 0%, #CB97FF 100%)",
                backgroundOrigin: "border-box",
                backgroundClip: "padding-box, border-box",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
              }}
            >
              বিস্তারিত দেখুন
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FreeCourseClass;
